import { Eyebrow, FadeUp } from "../Reveal";

const CHAPTERS = [
  {
    numeral: "I",
    title: "Access beyond boundaries",
    text: "What is impossible for others is our starting point — tables that do not exist, doors that do not open, skies that do not wait.",
  },
  {
    numeral: "II",
    title: "Precision and intuition",
    text: "We anticipate desires before they are articulated, shaping every detail precisely to the rhythm of your life.",
  },
  {
    numeral: "III",
    title: "Enduring discretion",
    text: "Your identity, preferences and movements are guarded with absolute confidentiality — always.",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="bg-[#080808] py-24 md:py-32">
    <FadeUp className="text-center">
      <Eyebrow center>The MDS Standard</Eyebrow>
    </FadeUp>
    <div className="mx-auto mt-14 max-w-[1040px] px-6 lg:px-12">
      {CHAPTERS.map((c, i) => (
        <FadeUp key={c.numeral} delay={i * 0.1}>
          <div
            data-testid={`manifesto-chapter-${i + 1}`}
            className={`group grid items-baseline gap-3 py-10 sm:grid-cols-[90px_1fr_1.35fr] sm:gap-10 ${
              i > 0 ? "border-t border-[rgba(200,164,93,0.16)]" : "border-t border-[rgba(200,164,93,0.16)]"
            }`}
          >
            <span className="gold-text font-serif text-[44px] font-light italic leading-none">
              {c.numeral}
            </span>
            <h3 className="font-serif text-2xl font-medium text-ivory transition-colors duration-500 group-hover:text-champagne-light sm:text-[28px]">
              {c.title}
            </h3>
            <p className="max-w-md text-sm font-light leading-relaxed text-ivory-muted">
              {c.text}
            </p>
          </div>
        </FadeUp>
      ))}
      <div className="border-t border-[rgba(200,164,93,0.16)]" />
    </div>
  </section>
);
